import { render, staticRenderFns } from "./GoodsHistoryList.vue?vue&type=template&id=997a69fe&"
import script from "./GoodsHistoryList.vue?vue&type=script&lang=js&"
export * from "./GoodsHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsHistoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoodsHistoryItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsHistoryItem.vue').default})
